<i18n locale="en">
  {
    "close": "Close"
  }
</i18n>

<template>
  <div class="dialog-heading flex-row gap-6 align-center justify-between">
    <div class="flex-row gap-3 align-center">
      <slot name="icon-left" />
      <div class="flex-col gap-1">
        <OwnType v-if="title" :text="title" variant="title-large" />
        <OwnType v-if="subtitle" :text="subtitle" variant="title-small" />
      </div>
    </div>
    <OwnButton
      v-if="!isPersistent"
      :aria-label="t('close')"
      @click="emit('cancel')"
    >
      <template #icon-left>
        <PhX size="24" />
      </template>
    </OwnButton>
  </div>
</template>

<script lang="ts" setup>
import { PhX } from '@phosphor-icons/vue'
import { inject, ref, computed, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { OwnButton } from '../OwnButton'
import { OwnType } from '../OwnType'

const { t } = useI18n()

withDefaults(defineProps<{ subtitle?: string; title?: string }>(), {
  subtitle: undefined,
  title: undefined,
})

// Inject the persistent state from parent dialog
const dialogPersistentRef = inject<Ref<boolean>>('dialogPersistent', ref(false))
const isPersistent = computed(() => dialogPersistentRef.value)

const emit = defineEmits<(event: 'cancel') => void>()
</script>

<style lang="scss" scoped>
.dialog-heading {
  border-bottom: 0.5px solid var(--divider);
  padding: 24px;
}
</style>
